import React, { useEffect, useMemo, useState } from "react";

import {
  Row,
  Col,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Alert,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "../../store/actions";

// import images
import logo from "../../assets/images/logo-sm.svg";

//Import config
import CarouselPage from "./CarouselPage";

const Login = (props: any) => {
  const dispatch = useDispatch();

  const { error, loading } = useSelector((state: any) => state.login);

  useEffect(() => {
    document.title = "Login | Admin & Dashboard";
  }, []);

  const validation = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  const [passwordShow, setPasswordShow] = useState(false);
  const togglePassword = () => setPasswordShow((prev) => !prev);

  const errorMessage = useMemo(() => {
    if (!error) return "";
    if (typeof error === "string") return error;
    return (
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Login failed. Please try again."
    );
  }, [error]);

  const isSubmitDisabled = loading || !validation.values.email || !validation.values.password;

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to="/dashboard" className="d-block auth-logo">
                        <img src={logo} alt="" height="28" />{" "}
                        <span className="logo-txt">Company</span>
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Welcome Back !</h5>
                        <p className="text-muted mt-2">
                          Sign in to continue to Dashboard.
                        </p>
                      </div>
                      <Form
                        className="custom-form mt-4 pt-2"
                        onSubmit={validation.handleSubmit}
                      >
                        {errorMessage ? (
                          <Alert color="danger">{errorMessage}</Alert>
                        ) : null}
                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            autoComplete="username"
                            autoFocus
                            inputMode="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              !!(validation.touched.email &&
                                  validation.errors.email)
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          {/* <Label className="form-label">Password</Label> */}
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <Label className="form-label">Password</Label>
                            </div>
                          </div>
                          <div className="input-group auth-pass-inputgroup">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              placeholder="Enter Password"
                              autoComplete="current-password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                !!(validation.touched.password &&
                                    validation.errors.password)
                              }
                            />
                            <button
                              onClick={togglePassword}
                              className="btn btn-light shadow-none ms-0"
                              type="button"
                              id="password-addon"
                              aria-label={passwordShow ? "Hide password" : "Show password"}
                            >
                              <i className={passwordShow ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"}></i>
                            </button>
                            {validation.touched.password &&
                              validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col">
                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-primary btn-block"
                                type="submit"
                                disabled={isSubmitDisabled}
                              >
                                {loading ? "Logging in..." : "Log In"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>

                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
